export default __webpack_public_path__ + "static/media/gear.182d7a1c.gif";